/**
 * Maps CropMap sidebar routes to permission key prefixes.
 * Backend codes are expected like `{permissionKey}_get` (e.g. `operations_get`).
 * Adjust keys to match your IAM permission codes.
 */
export interface CropMapPermissionMenuItem {
    routerLink: string;
    /** Permission code without `_get` suffix */
    permissionKey: string;
}

export const CROPMAP_PERMISSION_MENU_ITEMS: CropMapPermissionMenuItem[] = [
    { routerLink: '/plantation', permissionKey: 'plantation' },
    { routerLink: '/dashboard', permissionKey: 'dashboard' },
    { routerLink: '/report', permissionKey: 'report' },
    { routerLink: '/inquiry', permissionKey: 'inquiry' },
    { routerLink: '/operations', permissionKey: 'operations' },
    { routerLink: '/account', permissionKey: 'account' },
];
